var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigTvIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "23px",
    viewBox: "0 0 33 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4266181,0 L2.57349628,0 C1.15441324,0 0,0.941184579 0,2.09794462 L0,17.9777071 C0,19.1344671 1.15441324,20.0756517 2.57349628,20.0756517 L12.1229975,20.0756517 L12.1229975,21.4148863 L9.78420411,21.4148863 L9.78420411,23 L22.9941321,23 L22.9941321,21.4148863 L20.8770025,21.4148863 L20.8770025,20.0756517 L30.4265037,20.0756517 C31.8455868,20.0756517 33,19.1344671 33,17.9777071 L33,2.09794462 C33,0.941184579 31.8455868,0 30.4266181,0 Z M31.2162162,17.8976476 C31.2162162,18.1746721 30.9309337,18.4 30.5801993,18.4 L2.41980066,18.4 C2.06906626,18.4 1.78378378,18.1746721 1.78378378,17.8976476 L1.78378378,2.34235236 C1.78378378,2.06532787 2.06906626,1.84 2.41980066,1.84 L30.5801993,1.84 C30.9309337,1.84 31.2162162,2.06532787 31.2162162,2.34235236 L31.2162162,17.8976476 L31.2162162,17.8976476 Z",
    id: "Shape",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigTvIcon);
export default __webpack_public_path__ + "static/media/BigTVIcon.fca366b801cb76d5fe3d90ad105ae147.svg";
export { ForwardRef as ReactComponent };